import { render, staticRenderFns } from "./followView.vue?vue&type=template&id=3c32982b&scoped=true"
import script from "./followView.vue?vue&type=script&lang=js"
export * from "./followView.vue?vue&type=script&lang=js"
import style0 from "./followView.vue?vue&type=style&index=0&id=3c32982b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c32982b",
  null
  
)

export default component.exports